import React, { useState } from 'react';
import {
  AccountSettingsTab,
  AccountSettingsTabContent,
  AccountSettingsTabHeader,
  AccountSettingsTabHeaderLeft,
  AccountSettingsTabHeaderRight,
  AccountSettingsTableContainer,
  AccountSettingsTabSubtitle,
  AccountSettingsTabTitle,
} from '../../../../layouts/accountSettingsLayout/accountSettingsTab/accountSettingsTab';
import { Button, SearchInput, Text, Icon, countries, Flag } from '@bloobirds-it/flamingo-ui';
import { TargetMarketModal } from './targetMarketModal/targetMarketModal';
import styles from '../businessAssetsPage.module.css';
import { ExampleBusinessAsset } from '../exampleBusinessAsset/exampleBusinessAsset';
import { TargetMarketsList } from './targetMarketsList/targetMarketsList';
import { useOpenTargetMarketModal } from '../../../../hooks/useSteppableModal';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { TargetMarketsButton } from '../../../../components/targetMarketsButton/targetMarketsButton';
import TargetMarketsModal from '../../../../components/targetMarketsModal/targetMarketsModal';
import { useTargetMarketsModal } from '../../../../hooks/useTargetMarketsModal';

const TargetMarketTab = () => {
  const {
    modalOpen,
    handleCloseTargetMarketModal,
    handleOpenCreateEditModal,
    isCreation,
  } = useOpenTargetMarketModal();
  const [showExamplePage, setShowExamplePage] = useState();
  const [lenguage, setLenguage] = useState();
  const [searchValue, setSearchValue] = useState();
  const { isSmallDesktop } = useMediaQuery();
  const { isOpen: isOpenTargetMarketsModal, closeTargetMarketsModal } = useTargetMarketsModal();

  return (
    <AccountSettingsTab>
      {!showExamplePage ? (
        <>
          <AccountSettingsTabHeader>
            <AccountSettingsTabHeaderLeft>
              <AccountSettingsTabTitle icon="company" color="purple">
                <div className={styles._business_asset_title}>
                  Target markets
                  <TargetMarketsButton size="small" textBefore="Check your" />
                </div>
              </AccountSettingsTabTitle>
              <AccountSettingsTabSubtitle>
                A target market is a group of individuals sharing similar needs or characteristics
                that your solution can add value to. Identifying a target market helps your company
                develop effective sales and marketing strategies!{' '}
                <span onClick={() => setShowExamplePage(true)}>
                  <Text htmlTag="span" size="xs" color="purple" className={styles._link}>
                    See some examples
                  </Text>
                </span>
              </AccountSettingsTabSubtitle>
            </AccountSettingsTabHeaderLeft>
            <AccountSettingsTabHeaderRight>
              <SearchInput
                width={200}
                placeholder="Search"
                onChange={value => setSearchValue(value)}
                color="purple"
              />
              <Button
                iconLeft="plus"
                onClick={() => handleOpenCreateEditModal({ isCreationType: true })}
                color="purple"
              >
                {!isSmallDesktop && 'New Target Market'}
              </Button>
            </AccountSettingsTabHeaderRight>
          </AccountSettingsTabHeader>
          <AccountSettingsTabContent>
            <AccountSettingsTableContainer>
              <TargetMarketsList
                searchValue={searchValue}
                setShowExamplePage={setShowExamplePage}
              />
            </AccountSettingsTableContainer>
          </AccountSettingsTabContent>
          {modalOpen && (
            <TargetMarketModal handleClose={handleCloseTargetMarketModal} isCreation={isCreation} />
          )}
          {isOpenTargetMarketsModal && (
            <TargetMarketsModal handleCloseModal={closeTargetMarketsModal} />
          )}
        </>
      ) : (
        <>
          <AccountSettingsTabHeader>
            <AccountSettingsTabHeaderLeft>
              <AccountSettingsTabTitle icon="company">
                <span className={styles._title__container}>
                  <span>Target markets example</span>
                  <span
                    className={styles._lenguage__text__container}
                    onClick={() => setLenguage('EN')}
                  >
                    <Flag code={countries.find(x => x.code === 'GB')?.code} />
                    <Text size="s" color="bloobirds" inline className={styles._lenguage__text}>
                      English example
                    </Text>
                  </span>
                  <span
                    className={styles._lenguage__text__container}
                    onClick={() => setLenguage('ES')}
                  >
                    <Flag code={countries.find(x => x.code === 'ES')?.code} />
                    <Text size="s" color="bloobirds" inline className={styles._lenguage__text}>
                      Ejemplo en español
                    </Text>
                  </span>
                </span>
              </AccountSettingsTabTitle>
            </AccountSettingsTabHeaderLeft>
            <AccountSettingsTabHeaderRight>
              <span onClick={() => setShowExamplePage(false)} className={styles._link}>
                <Icon name="cross" color="bloobirds" size={24} />
              </span>
            </AccountSettingsTabHeaderRight>
          </AccountSettingsTabHeader>
          <AccountSettingsTabContent>
            <ExampleBusinessAsset type={'Target Market'} lenguage={lenguage || 'EN'} />
          </AccountSettingsTabContent>
        </>
      )}
    </AccountSettingsTab>
  );
};

export default TargetMarketTab;
